<template>
	<div class="additional-questions">
		<!-- Regular Questions Section -->
		<div v-if="regularQuestions.length > 0">
			<div class="section-subheader">Sorular</div>
			<v-row v-for="(item, index) in regularQuestions" :key="`question_${index}`">
				<v-col>
					<fieldset class="talentics-fieldset talentics-fieldset-paddings">
						<legend>
							{{ handleGetQuestion({ item }) }}
							<span v-if="isRequired(item)" class="required-indicator">*</span>
						</legend>
						<div class="answer-text">
							{{ handleGetAnswer({ item }) }}
						</div>
					</fieldset>
				</v-col>
			</v-row>
		</div>

		<!-- Approval Checkboxes Section -->
		<div v-if="approvalCheckboxes.length > 0" class="checkboxes-section">
			<div class="section-subheader">Onay Kutuları</div>
			<v-row v-for="(item, index) in approvalCheckboxes" :key="`checkbox_${index}`">
				<v-col>
					<fieldset class="talentics-fieldset talentics-fieldset-paddings">
						<legend>
							{{ handleGetQuestion({ item }) }}
							<span v-if="isRequired(item)" class="required-indicator">*</span>
						</legend>
						<div>
							<v-icon 
								:color="item.value === true ? 'success' : 'error'" 
								small
							>
								{{ item.value === true ? 'check_circle' : 'cancel' }}
							</v-icon>
						</div>
					</fieldset>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AdditionalQuestions',
	props: {
		questionSet: {
			type: Array,
			required: false,
			default() {
				return [];
			},
		},
		answerSet: {
			type: Array,
			required: false,
			default() {
				return [];
			},
		},
	},
	computed: {
		regularQuestions() {
			return this.answerSet.filter(item => item.type !== 'approval_checkbox');
		},
		approvalCheckboxes() {
			return this.answerSet.filter(item => item.type === 'approval_checkbox');
		},
	},
	methods: {
		isRequired(item) {
			if (item.required !== undefined) {
				return item.required === true;
			}
			
			const { questionSet } = this;
			const { propName } = item;

			if (propName && questionSet) {
				const question = questionSet.find(
					questionSetItem => questionSetItem.propName === propName,
				);
				
				if (question && question.required !== undefined) {
					return question.required === true;
				}
			}
			
			return false;
		},
		handleGetAnswer({ item }) {
			const { questionSet } = this;
			const { propName } = item;

			if (propName) {
				const question = questionSet.find(
					questionSetItem => questionSetItem.propName === propName,
				);
				
				if (question) {
					if (question.type === 'dropdown' || question.type === 'radio') {
						const { options } = question;
						const option = options.find(
							optionItem => optionItem.value === item.value,
						);

						if (option) {
							return option.label;
						} else {
							return item.value || '-';
						}
					} else {
						return item.value || '-';
					}
				} else {
					return item.value || '-';
				}
			} else {
				return item.value || '-';
			}
		},
		handleGetQuestion({ item }) {
			const { questionSet } = this;
			const { propName } = item;

			if (propName) {
				const question = questionSet.find(
					questionSetItem => questionSetItem.propName === propName,
				);

				if (question) {
					return question.label;
				} else {
					return item.label;
				}
			} else {
				return item.label;
			}
		},
	},
};
</script>

<style scoped>
.additional-questions {
	/* Container styles if needed */
}

.section-subheader {
	font-size: 0.8125rem;
	font-weight: 500;
	color: rgba(0, 0, 0, 0.7);
	margin-bottom: 12px;
}

.theme--dark .section-subheader {
	color: rgba(255, 255, 255, 0.7);
}

.checkboxes-section {
	margin-top: 20px;
}

.required-indicator {
	color: #f44336;
	margin-left: 4px;
}

.answer-text {
	font-size: 0.875rem;
	color: rgba(0, 0, 0, 0.87);
}

.theme--dark .answer-text {
	color: rgba(255, 255, 255, 0.87);
}
</style>